import { Box, Switch, Typography } from "@mui/material";
import React from "react";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";

interface HQToggleProps {
  toggleOn: boolean;
  setToggleOn: React.Dispatch<React.SetStateAction<boolean>>;
}

const HQToggle = ({ toggleOn, setToggleOn }: HQToggleProps) => {
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToggleOn(event.target.checked);
  };

  const { closePopup } = usePanoramaPopupStore();

  React.useEffect(() => {
    if (!toggleOn) {
      closePopup();
    }
  }, [toggleOn, closePopup]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid white",
        borderRadius: "8px",
        padding: "8px 16px",
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        color: "white",
        width: "220px",
      }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: "700",
          letterSpacing: "-0.43px",
        }}
      >
        HQ 설계 모델
      </Typography>
      <Switch
        checked={toggleOn}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#4A90E2",
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#4A90E2",
          },
        }}
        onChange={handleToggle}
      />
    </Box>
  );
};
  
export default HQToggle;
